// ----------------------------------------------------------------------------
//  Frontend-Validatoren / Normalisierer (1:1 zur Backend-Logik in ContactNormalizer.cs).
//  Zentral hier, damit Anpassungen nicht in mehreren Formularen nachgezogen werden müssen.
// ----------------------------------------------------------------------------

const EMAIL_RE       = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_FINAL_RE = /^\+[1-9]\d{7,15}$/;

export function normalizeEmail(v) {
  if (!v) return '';
  return v.trim().toLowerCase();
}

export function isEmail(v) {
  if (!v) return true; // leer = optional, daher gültig
  return EMAIL_RE.test(v.trim());
}

export function normalizePhone(v) {
  if (!v) return '';
  let raw = v.trim().replace(/[\s\-/.()]/g, '');
  if (!raw) return '';
  if (raw.startsWith('00')) raw = '+' + raw.slice(2);
  else if (raw.startsWith('0')) raw = '+49' + raw.slice(1);
  else if (!raw.startsWith('+') && /^\d+$/.test(raw)) raw = '+49' + raw;
  return raw;
}

export function isPhone(v) {
  if (!v) return true; // leer = optional, daher gültig
  return PHONE_FINAL_RE.test(v.trim());
}
